import { render, staticRenderFns } from "./complaints-by-category.vue?vue&type=template&id=46ceb126&scoped=true&"
import script from "./complaints-by-category.vue?vue&type=script&lang=js&"
export * from "./complaints-by-category.vue?vue&type=script&lang=js&"
import style0 from "./complaints-by-category.vue?vue&type=style&index=0&id=46ceb126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ceb126",
  null
  
)

export default component.exports